import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable, Subject } from 'rxjs';
import type { ISosService } from '@core-interfaces/services/sos';
import type { IPaginatedSos, ISosAdminDetail, ISosRequest } from '@core-interfaces/dtos/sos';
import { Microservice } from '@core-interfaces/global/microservice';
import { ApiSuccessResponse } from '@core-interfaces/global/http';

@Injectable({ providedIn: 'root' })
export class SosService implements ISosService {
  constructor(private http: HttpClient) {}

  private baseUrl = `/${Microservice.backoffice_service}/sos`;

  private pendingBadgeRefresh = new Subject<void>();
  pendingBadgeRefresh$ = this.pendingBadgeRefresh.asObservable();

  notifyPendingBadgeRefresh(): void {
    this.pendingBadgeRefresh.next();
  }

  getSosRequests(params?: { after?: number; first?: number; status?: string }): Observable<IPaginatedSos> {
    let httpParams = new HttpParams();
    if (params?.after !== undefined) httpParams = httpParams.set('after', params.after.toString());
    if (params?.first !== undefined) httpParams = httpParams.set('first', params.first.toString());
    if (params?.status) httpParams = httpParams.set('status', params.status);
    return this.http
      .get<ApiSuccessResponse<IPaginatedSos>>(this.baseUrl, { params: httpParams })
      .pipe(map((response) => response.data));
  }

  getSosDetail(id: number): Observable<ISosAdminDetail> {
    return this.http
      .get<ApiSuccessResponse<ISosAdminDetail>>(`${this.baseUrl}/${id}`)
      .pipe(map((response) => response.data));
  }

  resolveSos(id: number, payload: { admin_notes?: string | null }): Observable<ISosRequest> {
    return this.http
      .put<ApiSuccessResponse<ISosRequest>>(`${this.baseUrl}/${id}/resolve`, payload)
      .pipe(map((response) => response.data));
  }

  updateNotes(id: number, payload: { admin_notes?: string | null }): Observable<ISosRequest> {
    return this.http
      .put<ApiSuccessResponse<ISosRequest>>(`${this.baseUrl}/${id}/notes`, payload)
      .pipe(map((response) => response.data));
  }
}
